var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('BaseBreadcrumb',{attrs:{"title":_vm.page.title,"icon":_vm.page.icon,"breadcrumbs":_vm.breadcrumbs}}),_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"12"}},[_c('BaseCard',{attrs:{"heading":"Forma de Pagamento"}},[_c('listar-forma-pagamento')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }